'use strict';

const { CLASSES } = require('../utils/globals');

const SELECTORS = {
    inputField: '.js-input-field',
    inputLabel: '.f-field-placeholder',
    inputFieldWrapper: '.js-field-wrapper',
    webkitAutofill: ':-webkit-autofill',
};

const getInputFieldParent = ($element) => $element.closest(SELECTORS.inputFieldWrapper);

const changeFilledFields = () => {
    $(SELECTORS.inputField).each((index, element) => {
        const $this = $(element);

        if ($this.val().length) {
            getInputFieldParent($this).addClass(CLASSES.placeholderUp);
        } else {
            getInputFieldParent($this).removeClass(CLASSES.placeholderUp);
        }

        if ($(element).is(SELECTORS.webkitAutofill)) {
            getInputFieldParent($this).addClass(CLASSES.placeholderUp);
        } else {
            getInputFieldParent($this).removeClass(CLASSES.placeholderUp);
        }
    });
};

const togglePlaceholderUp = (e) => {
    const $this = $(e.currentTarget);
    const EVENT = e.type;

    if (EVENT === 'focusin' || EVENT === 'click') {
        getInputFieldParent($this).addClass(CLASSES.placeholderUp);

        if ($this.is('label')) {
            $this.siblings(SELECTORS.inputField).trigger('focus');
        }

    } else {
        if (!$this.val().length) {
            getInputFieldParent($this).removeClass(CLASSES.placeholderUp);
        }
    }
};

const initEvents = () => {
    $(document).on('focus', SELECTORS.inputField, togglePlaceholderUp);
    $(document).on('blur', SELECTORS.inputField, togglePlaceholderUp);
    $(document).on('click', SELECTORS.inputLabel, togglePlaceholderUp);
    $(document).on('input', SELECTORS.inputLabel, togglePlaceholderUp);

    $(window).on( 'load', () => setTimeout(changeFilledFields, 200));

    // Custom event, trigger it when you need to update the fields
    $(document).on('fields:updated', changeFilledFields)
};

module.exports = () => {
    initEvents();
};
